import { getGuardId, memo } from '@morphic-ts/common/es6/utils';
import { ShowType, ShowURI } from './../hkt';
/**
 *  @since 0.0.1
 */
export const showUnionInterpreter = memo(() => ({
    _F: ShowURI,
    union: items => (guards, _name) => (env) => {
        const items_ = items.map(_ => _(env).show.show);
        const guardId = getGuardId(guards, Symbol());
        return new ShowType({
            show: a => items_[guardId(a)](a)
        });
    }
}));
